import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { BrowserRouter } from "react-router";
import { cardBasePath } from "@/app/base-path";
import { themeFor } from "@/app/theme";
import { CardSchemeProvider, useCardScheme } from "@/app/use-card-scheme";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

type AppProvidersProps = {
	children: React.ReactNode;
};

function ThemedCard({ children }: AppProvidersProps) {
	const { scheme, theme } = useCardScheme();

	return (
		<MantineProvider theme={themeFor(theme, scheme)} forceColorScheme={scheme}>
			<Notifications position="top-center" />
			<BrowserRouter basename={cardBasePath() || "/"}>{children}</BrowserRouter>
		</MantineProvider>
	);
}

export function AppProviders({ children }: AppProvidersProps) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						retry: 1,
						staleTime: 0,
						gcTime: 0,
						refetchOnWindowFocus: true,
					},
				},
			}),
	);

	return (
		<QueryClientProvider client={queryClient}>
			<CardSchemeProvider>
				<ThemedCard>{children}</ThemedCard>
			</CardSchemeProvider>
		</QueryClientProvider>
	);
}
